import 'element-dataset';
import 'mdn-polyfills/Array.from';
import 'mdn-polyfills/Element.prototype.classList';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/Object.assign';
import 'mdn-polyfills/CustomEvent';
import 'svgxuse';
import 'picturefill';



// WEBPACK FOOTER //
// ./src/scripts/polyfills.js